import React from "react";
import GameUpdateBalance from "../components/updatebalance";
export function UpdatebalancePage() {
  return (
    <div>
      <GameUpdateBalance />
    </div>
  );
}
export default UpdatebalancePage;
